// Interface

import util from '@/utils/classToObject'
import { IMissionState } from './state'
import { AloMission } from '@/models/alo/AloMission'

const filterGlidersPredicate = (mission: AloMission, gliderIds: Array<number>, strictShow: boolean = false) =>
  (!strictShow && gliderIds.length == 0) || gliderIds.indexOf(mission.gliId!) > -1
const filterEnseignePredicate = (mission: AloMission, ensIds: Array<number>) =>
  ensIds.length == 0 || ensIds.indexOf(mission.ensId!) > -1
//const filterMissionFleetsPredicate = (mission:AloMission, missionFleetIds:Array<number>) => (missionFleetIds.length == 0 || missionFleetIds.indexOf(mission.missionFleetId) > -1)
const filterAlarmsPredicate = (mission: AloMission, alarmIds: Array<string>) =>
  alarmIds.length == 0 || (mission.misActifOn && alarmIds.some(a => mission.alarmStatusLast.some(s => s == a)))
const filterOnGoingPredicate = (mission: AloMission, ongoing: boolean) => mission.misActifOn == ongoing
const filterSimulatedPredicate = (mission: AloMission, simulated: boolean) => mission.isTestMission == simulated

export class MissionGetter {
  public filterEnseignePredicate(state: IMissionState) {
    return (m: AloMission) => filterEnseignePredicate(m, state.filterMission.ensIds)
  }

  public missions(state: IMissionState) {
    return state.missions
  }

  public enseigneMisssions(state: IMissionState) {
    return state.missions.filter(m => filterEnseignePredicate(m, state.filterMission.ensIds))
  }

  public missionsPassedLoading(state: IMissionState) {
    return state.missionsPassedLoading
  }

  //Tableau des id de gliders pour lesquels les missions ont été chargées
  public missionsPassedLoaded(state: IMissionState) {
    return state.missionsPassedLoaded
  }

  public refreshPicture(state: IMissionState) {
    return state.refreshPicture
  }

  public missionsOngoingLoading(state: IMissionState) {
    return state.missionsOngoingLoading
  }

  public missionsById(state: IMissionState) {
    return state.missions.reduce((acc, mission) => {
      if (!acc[mission.misId!] || mission._detailLoaded) acc[mission.misId!] = mission
      return acc
    }, {} as { [id: number]: AloMission })
  }

  public ongoingMissions(state: IMissionState, getters: any, rootState: any) {
    return state.missions.filter(
      m =>
        m.misActifOn &&
        m.isTestMission == rootState.ui.simulatedMissionActive &&
        filterEnseignePredicate(m, state.filterMission.ensIds),
    )
  }

  public currentDetailMission(state: IMissionState) {
    return state.currentDetailMission
  }

  public filterMission(state: IMissionState) {
    return state.filterMission
  }
  public allowedGliderFilterIds(state: IMissionState, getters: any, rootState: any) {
    return state.missions
      .filter(
        m =>
          filterEnseignePredicate(m, state.filterMission.ensIds) &&
          filterAlarmsPredicate(m, state.filterMission.alarmIds) &&
          filterOnGoingPredicate(m, false) &&
          filterSimulatedPredicate(m, rootState.ui.simulatedMissionActive),
      )
      .reduce((acc, mission) => {
        acc[mission.gliId!] = true
        return acc
      }, {} as { [id: number]: boolean })
  }

  public allowedEnsFilterIds(state: IMissionState, getters: any, rootState: any) {
    //   return state.missions.filter(m =>
    //   filterGlidersPredicate(m,state.filterMission.gliderIds) &&
    //   filterAlarmsPredicate(m,state.filterMission.alarmIds) &&
    //   filterOnGoingPredicate(m, false) &&
    //   filterSimulatedPredicate(m, rootState.ui.simulatedMissionActive)
    // )
    return state.missions.reduce((acc, mission) => {
      acc[mission.ensId!] = true
      return acc
    }, {} as { [id: number]: boolean })
  }

  public filterMissionFleetIds(state: IMissionState) {
    return state.filterMission.fleetIds
  }

  /*public allowedMissionFleetFilterIds(state:IMissionState) {
      return state.missions.filter(m =>     
      //filterGlidersPredicate(m,state.filterMission.gliderIds) &&    
      //filterAlarmsPredicate(m,state.filterMission.alarmIds) &&
      filterOnGoingPredicate(m,state.filterMission.ongoing)
    ).reduce((acc,mission) => {
        acc[mission.missionFleetId] = true
        return acc
      },{} as {[id:number]:boolean})
  }*/

  public allowedAlarmFilterIds(state: IMissionState, getters: any, rootState: any) {
    return state.missions
      .filter(
        m =>
          m.misActifOn &&
          filterGlidersPredicate(m, state.filterMission.gliderIds) &&
          filterEnseignePredicate(m, state.filterMission.ensIds) &&
          //filterMissionFleetsPredicate(m,state.filterMission.fleetIds) &&
          filterOnGoingPredicate(m, false) &&
          filterSimulatedPredicate(m, rootState.ui.simulatedMissionActive),
      )
      .reduce((acc, mission) => {
        mission.alarmStatusLast.forEach(a => (acc[a] = true))
        return acc
      }, {} as { [id: string]: boolean })
  }

  public filteredMission(state: IMissionState, getters: any, rootState: any) {
    return state.missions.filter(
      m =>
        filterGlidersPredicate(m, state.filterMission.gliderIds, true) &&
        filterEnseignePredicate(m, state.filterMission.ensIds) &&
        //filterMissionFleetsPredicate(m,state.filterMission.fleetIds) &&
        filterAlarmsPredicate(m, state.filterMission.alarmIds) &&
        filterOnGoingPredicate(m, false) &&
        filterSimulatedPredicate(m, rootState.ui.simulatedMissionActive),
    )
  }

  public drawerMissions(state: IMissionState, getters: any, rootState: any) {
    return (rootState.ui.ongoingMissionActive ? getters.ongoingMissions : getters.filteredMission).sort(
      (a: AloMission, b: AloMission) => a?.misLibelle?.localeCompare(b?.misLibelle ?? ''),
    )
  }

  public detailMissions(state: IMissionState) {
    return state.detailMissions
  }

  public isSingleWayPointModuleVisible(state: IMissionState) {
    return (
      state.currentDetailMission.tabsleft.selected.indexOf('MissionDetailSingleWayPoint') == 0 ||
      state.currentDetailMission.tabsright.selected.indexOf('MissionDetailSingleWayPoint') == 0
    )
  }

  public isMissionPlanModuleVisible(state: IMissionState) {
    return (
      state.currentDetailMission.tabsleft.selected.indexOf('MissionDetailMissionPlan') == 0 ||
      state.currentDetailMission.tabsright.selected.indexOf('MissionDetailMissionPlan') == 0
    )
  }

  public isQuickControlModuleVisible(state: IMissionState) {
    return (
      state.currentDetailMission.tabsleft.selected.indexOf('MissionDetailQuickControl') == 0 ||
      state.currentDetailMission.tabsright.selected.indexOf('MissionDetailQuickControl') == 0
    )
  }

  public sendMailLoading(state: IMissionState) {
    return state.sendMailLoading
  }

  public originalSendMailConfigs(state: IMissionState) {
    return state.originalSendMailConfigs
  }

  public modifiedSendMailConfigs(state: IMissionState) {
    return state.modifiedSendMailConfigs
  }

  public missionPlanStagingLoading(state: IMissionState) {
    return state.missionPlanStagingLoading
  }

  public originalIrisMissionPlan(state: IMissionState) {
    return state.originalIrisMissionPlan
  }

  public missionPlanIrisLoading(state: IMissionState) {
    return state.missionPlanIrisLoading
  }

  public missionStatus(state: IMissionState) {
    return state.status
  }

  public originalMissionPlanConfigs(state: IMissionState) {
    return state.originalMissionPlanConfigs
  }

  public modifiedMissionPlanConfigs(state: IMissionState) {
    return state.modifiedMissionPlanConfigs
  }

  public missionPlanConfigLoading(state: IMissionState) {
    return state.missionPlanConfigLoading
  }

  public originalAd2cpConfigs(state: IMissionState) {
    return state.originalAd2cpConfigs
  }

  public modifiedAd2cpConfigs(state: IMissionState) {
    return state.modifiedAd2cpConfigs
  }

  public ad2cpLoading(state: IMissionState) {
    return state.ad2cpLoading
  }

  public originalCoriolisConfigs(state: IMissionState) {
    return state.originalCoriolisConfigs
  }

  public modifiedCoriolisConfigs(state: IMissionState) {
    return state.modifiedCoriolisConfigs
  }

  public coriolisLoading(state: IMissionState) {
    return state.coriolisLoading
  }

  public originalAisConfigs(state: IMissionState) {
    return state.originalAisConfigs
  }

  public modifiedAisConfigs(state: IMissionState) {
    return state.modifiedAisConfigs
  }

  public aisLoading(state: IMissionState) {
    return state.aisLoading
  }

  public originalQuickControlConfigs(state: IMissionState) {
    return state.originalQuickControlConfigs
  }

  public modifiedQuickControlConfigs(state: IMissionState) {
    return state.modifiedQuickControlConfigs
  }

  public quickcontrolConfigLoading(state: IMissionState) {
    return state.quickcontrolConfigLoading
  }

  public encryptionRevealLoading(state: IMissionState) {
    return state.encryptionRevealLoading
  }

  public encryptionSaveLoading(state: IMissionState) {
    return state.encryptionSaveLoading
  }
}
export default util.classToObject(MissionGetter)
